// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3U8bd","noInteraction":"EventWrapper_noInteraction__1j4sK","pointerPassthrough":"EventWrapper_pointerPassthrough__1RWSd"};